import classes from '@styles/scss/site/cardRating.module.scss';

export default function RatingSiteBox({ pros, cons }: { pros: any; cons: any }): JSX.Element {
    return (
        <>
            <div className={classes.siteBox + ' ' + classes.pros}>
                <strong>Pros</strong>
                <ul>
                    {pros.map((liText: string) => (liText ? <li key={liText}>{liText}</li> : null))}
                </ul>
            </div>
            <div className={classes.siteBox + ' ' + classes.cons}>
                <strong>Cons</strong>
                <ul>
                    {cons.map((liText: string) => (liText ? <li key={liText}>{liText}</li> : null))}
                </ul>
            </div>
        </>
    );
}
